export const actions = {
    insufficient_quota: {
        icon:"svg-spinners:3-dots-fade",
        systemText:'insufficient_quota',
        displayText:' '
    },
    human_reply: {
        icon:"svg-spinners:3-dots-fade",
        systemText:'human_reply',
        displayText:' '
    },
    agent_started: {
        icon:"svg-spinners:3-dots-fade",
        systemText:'agent_started',
        displayText:'typing'
    },
    consultation_tool: {
        systemText:'consultation_tool',
        displayText:"Setting schedule for consultancy ... ",
        icon:"svg-spinners:3-dots-fade",
    },
    feedback:{
        icon:'',
        systemText:'Feedback',
        displayText:'Feedback'
    },
    topic_ended: {
        icon:"svg-spinners:3-dots-fade",
        systemText:'topic_ended',
        displayText:'Topic Ended'
    },
    calling_supervisor: {
        systemText:'calling_supervisor',
        displayText:"Escalating conversation ... ",
        icon:"svg-spinners:3-dots-fade",
    },
    booking_appointment:{
        icon:'',
        systemText:'booking_appointment',
        displayText:'Scheduling an appointment...'
    },
    searching_knowledge: {
        icon:"svg-spinners:3-dots-fade",
        systemText:'searching_knowledge',
        displayText:'Searching my knowledge'
    },
    searching: {
        systemText:'searching',
        displayText:"Setting schedule for consultancy ... ",
        icon:"svg-spinners:3-dots-fade",
    },
    searching_web:{
        icon:"svg-spinners:3-dots-fade",
        systemText:'searching_web',
        displayText:'Surfing web ...'
    },
    final_answer:{
        icon:"svg-spinners:3-dots-fade",
        systemText:'final_answer',
        displayText:'Typing'
    },
    streaming_answer:{
        icon:"svg-spinners:3-dots-fade",
        systemText:'streaming_answer',
        displayText:'Typing'
    },
    nursing_syllabus_retriever:{
        icon:"svg-spinners:3-dots-fade",
        systemText:'nursing_syllabus_retriever',
        displayText:'searching private knowledge'
    },
    suggest_nearby_doctors:{
        icon:"svg-spinners:3-dots-fade",
        systemText:'suggest_nearby_doctors',
        displayText:'searching doctors nearby'
    },
    notebook_tool:{
        icon:"svg-spinners:3-dots-fade",
        systemText:'notebook_tool',
        displayText:'noting down conversation summary'
    },
};
